<template>
	<div :class="`prestep-new data-caid-${currentCard.id}`"
		:key="$store.state.calculatorRerender"
		:style="client.customization && client.customization.prestep_custom_bg ? { 'background-image': 'url(' + $apiUrl + '/storage/' + client.customization.prestep_custom_bg + ')' } : {}">
		<div class="prestep-new-top">
			<div class="prestep-new-top-logo">
				<img :src="$imgUrl(client.logo)">
			</div>
			<div class="prestep-new-top-close"
				v-if="currentCard.type_options && !currentCard.type_options.dont_show_skip_btn" @click="next('closed')">
				<img src="@/assets/img/clear.png" width="20">
			</div>

		</div>
		<div class="prestep-new-main">
			<div class="prestep-new-image-container">
				<v-img v-if="currentCard.image" class="prestep-new-image" :src="$imgUrl(currentCard.image)"
					:alt="currentCard.image_alt" />
			</div>
			<div class="prestep-new-content">
				<h2 class="prestep-new-content-title" v-html="$processText(currentCard.title)"></h2>
				<p class="prestep-new-content-intro" v-html="$processText(currentCard.wysiwyg)"></p>

				<div v-if="currentCard.type === 'new_prestep_language' && $store.state.endUser.client.id !== 24">
					<div v-if="currentCard.type_options && currentCard.type_options.text_above_input" class="mb-2"
						v-html="$processText(currentCard.type_options.text_above_input)"></div>
					<div class="btn prestep-new-btn transportation"
						:class="{ active: $store.state.endUser.language === 'sv' && 1 === 2 }"
						@click="setLanguage('sv')">
						Svenska</div>
					<div class="btn prestep-new-btn transportation"
						:class="{ active: $store.state.endUser.language === 'en' && 1 === 2 }"
						@click="setLanguage('en')">
						English</div>
				</div>
				<div v-if="currentCard.type === 'new_prestep_language' && $store.state.endUser.client.id === 24">
					<div v-if="currentCard.type_options && currentCard.type_options.text_above_input" class="mb-2"
						v-html="$processText(currentCard.type_options.text_above_input)"></div>
					<div class="btn prestep-new-btn transportation"
						:class="{ active: $store.state.endUser.language === 'tr' && 1 === 2 }"
						@click="setLanguage('tr')">
						Turkish</div>
					<div class="btn prestep-new-btn transportation"
						:class="{ active: $store.state.endUser.language === 'en' && 1 === 2 }"
						@click="setLanguage('en')">
						English</div>
				</div>

				<div v-if="currentCard.type === 'new_prestep_question'">
					<div v-if="currentCard.type_options && currentCard.type_options.text_above_input"
						class="mt-2 prestep-quiz-question"
						v-html="$processText(currentCard.type_options.text_above_input)">
					</div>

					<br>

					<div v-for="(answer, index) in question" :key="index" class="btn prestep-new-btn transportation"
						:class="{ active: isAnswer(answer) }" @click="answerQuestion(answer)">
						{{ answer.value }}
					</div>
				</div>

				<div v-if="currentCard.type === 'new_prestep_advanced_question'">
					<div v-if="currentCard.type_options && currentCard.type_options.text_above_input"
						class="mt-2 prestep-quiz-question"
						v-html="$processText(currentCard.type_options.text_above_input)">
					</div>

					<br>

					<div v-if="currentCard.type_options.question_type === 'open_ended'">
						<v-theme-provider light>
							<v-textarea v-model="openEndedAnswer"
								:label="__('write_your_answer', 'Skriv ditt svar')"
								:rules="[v => (currentCard.type_options.max_characters ? v.length <= currentCard.type_options.max_characters : true) || __('max_characters_exceeded', 'Max antal tecken överskridet')]"
								outlined></v-textarea>
						</v-theme-provider>
					</div>
					<div v-else v-for="(answer, index) in question" :key="index"
						class="btn prestep-new-btn transportation" :class="{ active: isAnswer(answer) }"
						@click="answerQuestion(answer)">
						{{ answer.value }}
					</div>
				</div>


				<div v-if="currentCard.type === 'new_prestep_consent'">
					<div class="mb-7" ref="consent_text">
						<v-checkbox hide-details v-model="consent">
							<template v-slot:label>
								<span class="consent-text"
									v-html="$processText(currentCard.type_options.consent_text)"></span>
							</template>
						</v-checkbox>
					</div>
				</div>

				<div v-if="currentCard.type === 'new_prestep_contact'">
					<v-text-field :error-messages="errors.email" :error="errors.email.length" :height="10"
						v-if="currentCard.type_options.input_email"
						:placeholder="__('write_your_email', 'Skriv in din e-postadress')" ref="email" v-model="email"
						outlined></v-text-field>
					<v-text-field :error-messages="errors.phone" :error="errors.phone.length" :height="10"
						v-if="currentCard.type_options.input_phone"
						:placeholder="__('write_your_phone', 'Skriv in ditt telefonnummer')" ref="phone" v-model="phone"
						outlined></v-text-field>
					<v-text-field :height="10" v-if="currentCard.type_options.input_first_name"
						:placeholder="__('write_your_first_name', 'Skriv in ditt förnamn')" ref="firstName"
						v-model="firstName" outlined></v-text-field>
				</div>

				<div v-if="currentCard.type === 'new_prestep_address'">
					<div v-if="currentCard.type_options && currentCard.type_options.text_above_input" class="mb-2"
						v-html="$processText(currentCard.type_options.text_above_input)"></div>
					<v-text-field :height="10" :placeholder="__('write_an_address', 'Skriv in en adress')" ref="to"
						v-model="to" outlined></v-text-field>
				</div>

				<div v-if="currentCard.type === 'new_prestep_transport'">
					<div class="mb-2" v-html="$processText(currentCard.type_options.text_above_input)"></div>
					<div class="prestep-new-content-transportation" v-if="!currentCard.type_options.input_home_address">
						<div class="btn prestep-new-btn transportation" v-for="layer in layers" :key="layer.id"
							@click="setTransportation(layer)"
							:style="isActive(layer.id) ? { 'background-color': (layer.icon_font_color || '#012169') + ' !important', 'border-color': layer.icon_font_color, 'color': '#fff' } : {}">
							<i v-if="layer.icon_font" :class="layer.icon_font"></i>

							<v-img v-if="layer.icon && !layer.icon_font" :src="$imgUrl(layer.icon)" height="20px" />

							{{ layer.__title }}
						</div>

						<div class="btn prestep-new-btn transportation" :class="misc ? 'active' : ''"
							@click="setMisc()">{{ __('prestep_other_transport', 'Annat') }}</div>
					</div>
				</div>

				<div class="prestep-new-content-bottom between">
					<div class="btn prestep-new-btn prev"
						:class="{ disabled: index === 0 && currentCard.type !== 'new_prestep_survey_completed' }"
						v-if="currentCard.type_options && !currentCard.type_options.disable_back_button && calculatedCards.length > 1 && currentCard.type !== 'new_prestep_language'"
						@click="prev()">
						<img src="@/assets/img/chevron-left.png" alt=""> {{ currentCard.type_options.back_btn_text || ''
						}}
					</div>

					<div class="prestep-new-content-bottom-page" v-if="currentCard.type !== 'new_prestep_language'">
						{{ index + 1 }} / {{ calculatedCards.length }}
					</div>

					<div class="btn prestep-new-btn"
						v-if="currentCard.type !== 'new_prestep_language' && (!currentCard.type_options || !currentCard.type_options.dont_show_next_btn)"
						@click="next('continue')" :class="{
							disabled:
								(currentCard.type === 'new_prestep_contact' &&
									((!email && currentCard.type_options.input_email)
										|| (!phone && currentCard.type_options.input_phone)))

						}">
						{{ (currentCard.type_options && currentCard.type_options.btn_text)
                || capitalize(__('prestep_next', 'Gå vidare'))
						}}
					</div>
				</div>

				<div class="prestep-new-gdpr"
					v-if="(currentCard.type_options && currentCard.type_options.gdpr_link) || client.footer_wysiwyg">
					<div v-if="client.footer_wysiwyg" v-html="$processText(client.footer_wysiwyg)"></div>
					<a v-if="!client.footer_wysiwyg" :href="$processText(currentCard.type_options.gdpr_link)"
						target="_blank"
						v-html="currentCard.type_options.gdpr_link_title || __('how_we_handle_data')"></a>
				</div>
			</div>
		</div>

		<!-- <img class="prestep-new-mobile-image" v-if="client.customization && client.customization.prestep_custom_bg"
			:src="$apiUrl + '/storage/' + client.customization.prestep_custom_bg_mobile">

		<img class="prestep-new-mobile-image" v-if="!client.customization || !client.customization.prestep_custom_bg"
			src="@/assets/img/prestep-illustration-mobile.jpg"> -->
		<LanguagePicker />
	</div>
</template>

<script>
import axios from 'axios'
import LanguagePicker from '@/components/LanguagePicker'

export default {
	name: 'PreStepNew',
	props: ['cards'],
	components: {
		LanguagePicker
	},

	watch: {
		'$store.state.endUser.language': {
			handler(newLang, oldLang) {
				this.reset() // Recalculates cards based on new language
			},
			immediate: true
		},
	},

	mounted() {
		this.$store.state.prestepOpen = true
		this.calculatedCards = this.filteredCards

		if (this.$refs.to) { this.activateAutocomplete() }

		if (this.$refs.consent_text) {
			// Enable outbound links inside the checkbox label
			this.$refs.consent_text.getElementsByTagName('a').forEach(a => {
				a.onclick = (e) => e.stopPropagation()
				a.target = '_blank'
			})
		}

		this.$metric({ 'event': 'prestep_interaction', 'InteractionType': 'loaded' })
	},

	data() {
		return {
			to: '',
			activeLayer: null,
			index: 0,
			misc: false,
			consent: false,
			answers: [],
			firstName: '',
			phone: '',
			email: '',
			openEndedAnswer: '',
			multiAnswers: [],
			errors: { phone: [], email: [] },
			calculatedCards: []
		}
	},

	methods: {
		reset() {
			// Reset all component state
			this.to = ''
			this.activeLayer = null
			this.index = 0
			this.misc = false
			this.consent = false
			this.answers = []
			this.firstName = ''
			this.phone = ''
			this.email = ''
			this.openEndedAnswer = ''
			this.multiAnswers = []
			this.errors = { phone: [], email: [] }

			// Reset store answers
			this.$store.state.answers = {}

			// Recalculate cards
			this.calculatedCards = this.filteredCards
		},

		answerQuestion(answer) {
			let previousIndex = this.answers.findIndex(a => {
				return a.title === this.currentCard.type_options.text_above_input
			})

			let newAnswer = {
				title: this.currentCard.type_options.text_above_input,
				answer: answer.value
			}

			if (previousIndex !== -1) {
				this.$set(this.answers, previousIndex, newAnswer)
			} else {
				this.answers.push(newAnswer)
			}
			this.$store.state.answers = {
				...this.$store.state.answers,
				[this.currentCard.id]: answer.key
			}

			// update calculatedCards based on new answers
			this.calculatedCards = this.cards.filter((card) => {
				if (card.type_options && card.type_options.show_if && card.type_options.show_if.trim() !== '') {
					let conditions = card.type_options.show_if.split('\n').map(str => str.trim());
					return conditions.every(condition => {
						let [key, value] = condition.split(':').map(str => str.trim());
						let answer = this.$store.state.answers[key];
						let isNotCondition = value.startsWith('not ');
						if (isNotCondition) {
							value = value.slice(4).trim();
						}
						if (value.includes('*')) {
							let regex = new RegExp('^' + value.replace(/\*/g, '.*') + '$');
							return isNotCondition ? !regex.test(answer) : regex.test(answer);
						}
						return isNotCondition ? answer !== value : answer === value;
					});
				}
				return true;
			})


			let answerToSend = answer.key;
			// If the question is open ended, send the answer as the openEndedAnswer
			if (this.currentCard.type_options.question_type === 'open_ended') {
				answerToSend = this.openEndedAnswer
			} else if (this.currentCard.type === 'new_prestep_advanced_question' && this.currentCard.type_options.question_type === 'multiple_choice') {
				if (this.multiAnswers.includes(answer.key)) {
					this.multiAnswers = this.multiAnswers.filter(a => a !== answer.key)
				} else {
					if (this.currentCard.type_options.maximum_allowed_answers && this.multiAnswers.length >= this.currentCard.type_options.maximum_allowed_answers) {
						// Remove the first answer to make room for the new one (FIFO)
						this.multiAnswers.shift();
					}
					this.multiAnswers.push(answer.key)
				}
				answerToSend = this.multiAnswers.join(',')
			}
			axios.post(this.$apiUrl + '/api/survey/11', {
				question: this.currentCard.type_options.text_above_input,
				cardId: this.currentCard.id,
        client_id: this.$store.state.client.id,
				answer: answerToSend,
				uuid: this.currentCard.id,
				slug: this.$store.state.endUser.slug,
			})
		},

		isAnswer(answer) {
			if (this.currentCard.type === 'new_prestep_advanced_question' && this.currentCard.type_options.question_type === 'multiple_choice') {
				return this.multiAnswers.includes(answer.key)
			}
			return this.answers.find(a => {
				return a.title === this.currentCard.type_options.text_above_input && a.answer === answer.value
			})
		},

		activateAutocomplete() {
			// GMaps autocomplete
			if (this.mapsApi) {
				let autoComplete = new this.mapsApi.maps.places.Autocomplete(this.$refs.to.$el.querySelector('input'),
					{ componentRestrictions: { country: 'se' } })

				autoComplete.addListener('place_changed', () => {
					this.$store.state.mapPreserveViewport = true
					this.$store.state.directions[this.currentCard.type_options.input_home_address ? 'from' : 'to'] = autoComplete.getPlace().formatted_address

					if (!this.currentCard.type_options.input_home_address) {
						this.$setCookie('toDestination', this.$store.state.directions.to)
					} else {
						this.$setCookie('fromDestination', this.$store.state.directions.from)
					}

					this.$metric({ 'event': 'prestep_interaction', 'InteractionType': 'destination' })
				})
			}
		},

		setMisc() {
			this.misc = true
			this.activeLayer = null
		},

		isActive(id) {
			if (!this.activeLayer) {
				return null
			}

			return this.activeLayer.id === id
		},

		async next(type) {
			// Reset multiAnswers
			this.multiAnswers = []
			this.$metric({ 'event': 'prestep_interaction', 'InteractionType': type })

			if (type === 'closed') {
				this.close()
			}

			if (this.currentCard.type === 'new_prestep_contact') {
				const data = {};
				if (this.currentCard.type_options.input_email) {
					data.email = this.email;
				}
				if (this.currentCard.type_options.input_phone) {
					data.phone = this.phone;
				}
				if (this.currentCard.type_options.input_first_name) {
					data.first_name = this.firstName;
				}
				try {
					const contact_preference = [];
					if (this.currentCard.type_options.input_email) {
						contact_preference.push('email');
					}
					if (this.currentCard.type_options.input_phone) {
						contact_preference.push('phone');
					}
					if (contact_preference.length === 0) {
						contact_preference.push('none');
					}
					await axios.post(this.$apiUrl + '/api/end-user/' + this.$store.state.endUser.slug + '/update-contact', {
						...data,
						contact_preference
					})
					this.errors.phone = []
					this.errors.email = []
				} catch (error) {
					for (let prop in error.response.data) {
						error.response.data[prop] = error.response.data[prop].map(e => this.__(e))
					}
					this.errors = { ...this.errors, ...error.response.data }
					return;
				}
			}

			if (this.currentCard.type === 'new_prestep_advanced_question') {
				if (this.currentCard.type_options.question_type === 'open_ended') {
					this.answerQuestion({ key: this.openEndedAnswer, value: this.openEndedAnswer })
					// Clear the text field for the next question
					this.openEndedAnswer = ''
				}
			}

			// If consent step, send the consent and save it on the end user
			if (this.currentCard.type === 'new_prestep_consent') {
				this.$store.state.endUser.googleMapsConsent = this.consent ? true : false

				const res = await axios.post(this.$apiUrl + '/api/end-user/' + this.$store.state.endUser.slug + '/update-consent', {
					consent: this.currentCard?.type_options?.consent_text,
					answer: this.consent ? 'yes' : 'no'
				})

				this.$store.commit('loadGoogleMaps')
				this.$setCookie('consentSlug', this.$store.state.endUser.slug);
			}

			if (this.index + 1 === this.calculatedCards.length) {
				this.close()
			} else {
				this.to = ''
				this.index++
			}

			this.$nextTick(() => {
				if (this.$refs.to) { this.activateAutocomplete() }

				// Additional check, to wait for Google Maps loading
				setTimeout(() => {
					if (this.$refs.to) { this.activateAutocomplete() }
				}, 700)
			})
		},



		prev() {
			if (this.currentCard.type === 'new_prestep_survey_completed' && this.currentCard.type_options.back_btn_link) {
				window.location.href = this.$processText(this.currentCard.type_options.back_btn_link) + '&fnp=1';
				return;
			}

			this.to = ''
			this.index--

			this.$nextTick(() => {
				if (this.$refs.to) { this.activateAutocomplete() }
			})
		},

		close(type) {
			// Cookie to only show prestep once
			this.$setCookie('finishedPrestep', 1)

			this.$router.push({ name: 'EndUser', query: { fnp: 1 } })
			this.$router.go()
		},

		setLanguage(lang) {
			this.$changeLang(lang)
			this.next('continue')
		},

		capitalize(string) {
			return string[0].toUpperCase() + string.slice(1)
		},

		setTransportation(layer) {
			if (this.activeLayer && !this.activeLayer.show_as_default) {
				this.activeLayer.active = false
				this.activeLayer.point_categories = this.activeLayer.point_categories.map(c => ({ ...c, active: false }))
			}

			// deactivate all layers
			this.$store.state.layers.filter(l => l.show_in_menu).forEach(l => {
				l.active = false
				return l
			})

			this.misc = false
			this.activeLayer = layer

			if (layer.title.includes('Promenad')) { this.$store.state.directions.travelMode = 'WALKING' }
			if (layer.title.includes('Cykel')) { this.$store.state.directions.travelMode = 'BICYCLING' }
			if (layer.title.includes('Kollektiv')) { this.$store.state.directions.travelMode = 'TRANSIT' }
			if (layer.title.includes('Bil')) { axios.post(this.$apiUrl + '/api/end-user/' + this.$store.state.endUser.slug + '/update-preferences', { means_of_transport: 'CAR' }) }
			if (layer.title.includes('Mer')) { axios.post(this.$apiUrl + '/api/end-user/' + this.$store.state.endUser.slug + '/update-preferences', { means_of_transport: 'OTHER' }) }

			layer.active = true
			layer.point_categories = layer.point_categories.map(c => ({ ...c, active: layer.active }))

			this.$metric({ 'event': 'prestep_interaction', 'InteractionType': 'transportation', 'TransportationType': layer.title })
		},
	},

	computed: {
		filteredCards() {
			return this.cards.filter(card => {
				if (card.type_options && card.type_options.show_if && card.type_options.show_if.trim() !== '') {
					return false
				}
				return true
			})
		},

		currentCard() {
			return this.calculatedCards[this.index]
		},

		mapsApi() {
			return this.$store.state.mapsApi
		},

		client() {
			return this.$store.state.client
		},

		question() {
			let rows = this.currentCard.type_options.question.split('\r\n')

			return rows.map(r => {
				let split = r.split(' : ')

				return {
					key: split[0],
					value: split[1]
				}
			})
		},

		layers() {
			return this.$store.getters.translatedLayers
				.filter(l => l.show_in_menu && !l.hidden)
				.filter(l => l.title !== 'Mer' && l.title !== 'More')
		},
	}
}
</script>
